import { render, staticRenderFns } from "./InputMessage.vue?vue&type=template&id=2418aaae&scoped=true&"
import script from "./InputMessage.vue?vue&type=script&lang=js&"
export * from "./InputMessage.vue?vue&type=script&lang=js&"
import style0 from "./InputMessage.vue?vue&type=style&index=0&id=2418aaae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418aaae",
  null
  
)

export default component.exports